/**
 * @author vishwadeep.kapoor
 * @Date: 2020-12-04 20:40:16
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2020-12-04 21:50:18
 */
import endPoints from '../../config/endPoints';

const EDGE_LANDING_CONSTANTS = {
  PRODUCTS: [
    {
      id: '1',
      slug: 'kuber-gift-card',
      summary: 'Single card for anything and everything',
      name: 'Kuber Gift Card',
      descriptionHtml: `<div><p>A perfect gift card to reward your employees and business associates.</p>
      <p className="padding-tb-1">The KUBER gift card is widely accepted at more than 750,000 merchant partners across ALL categories such as
        supermarkets, hypermarkets, restaurants, fuel stations, jewelry stores, hotels, and all eCommerce sites.
      </p>
      <p>Except for withdrawing cash, you can purchase anything under the sun using the Kuber card.</p>
      <p className="padding-t-1">Kuber gift card is also available in virtual format in addition to physical cards.
        The Kuber Gift Card is a non-reloadable card which comes with a 1-year validity period and a maximum load limit of 10,000 INR
      </p></div>`,
      imageTitle: '',
      imageDescription: endPoints.KUBER_GIFT_CARD_LOGO,
      summaryImage: endPoints.KUBER_GIFT_CARD,
    },
    {
      id: '2',
      slug: 'zinger-gpr-card',
      name: 'Zinger GPR card',
      summary: 'Reloadable card for all expenses',
      descriptionHtml: `<div><p>
      Zinger GPR (General Purpose Reloadable) Card is a reloadable card with a single wallet.
      This can be used at any online portal or offline store throughout India.
      The card is widely accepted at more than 750,000 merchant partners across ALL categories such as
      supermarkets, hypermarkets, restaurants, fuel stations, and e-commerce sites.
    </p>
    <p className="padding-t-1">Zinger GPR card is also available in virtual format in addition to physical card.
      Zinger GPR card can be loaded multiple times and comes with a 3-year validity period.
    </p></div>`,
      imageTitle: '',
      imageDescription: endPoints.ZINGER_GPR_CARD,
    },
    {
      id: '3',
      slug: 'zinger-multi-wallet-card',
      name: 'Zinger Multi Wallet card',
      summary: 'Single reloadable card with multiple wallets',
      descriptionHtml: `<div><p>
      Zaggle ZINGER Multi Wallet Card is an end to end payment solution specially designed for
      Corporates to make their payments/disbursement experiences to their stakeholders simpler and faster.
    </p>
    <p className="padding-t-1">The Zinger Card is a Multi Wallet Card that meets Corporates’ business expenses,
      incentives, and employees’ tax benefit allowances and expense reimbursements.
    </p>
    <p className="padding-t-1">The Corporate no longer undergoes the hassles of handling vouchers, multiple cards, multiple accounts, etc.
      Be it business expenses, Reward, meal allowance, or others, all that they need is a Zinger Multi wallet Card!
    </p>
    <p className="padding-t-1">Zinger multi wallet card is also available in virtual format in addition to physical cards.
      Zinger Multi Wallet card is a reloadable card with 3-year validity.
    </p></div>`,
      imageTitle: '',
      imageDescription: endPoints.EDGE_MULTI_WALLET_CARD,
      summaryImage: endPoints.ZINGER_MULTI_WALLET_CARD,
    },
    {
      id: '4',
      slug: 'wave-gift-card',
      name: 'Wave Gift card',
      summary: 'Multi Store card for various brands',
      descriptionHtml: `<div><p>
      The Wave Gift Card is designed for usage across an exquisite mix of brands for
      apparel, entertainment, electronics, home furnishings, jewellery, and dining.
    </p>
    <p className="padding-t-1">
      The Wave Card is also available in virtual format in addition to physical card.
      The Wave Card is a non-reloadable card that comes with a 1-year validity period and a maximum load limit of 10,000 INR.
      The card can be used both offline and online shopping. This card gives the choice to spend at any of the below brands:
    </p></div>`,
      imageTitle: endPoints.WAVE_GIFTCARD_PARTNER_LOGO,
      imageDescription: endPoints.WAVE_GIFT_CARD,
    },
    {
      id: '5',
      slug: 'wheels-gift-card',
      name: 'Wheels Gift Card',
      summary: 'Gift card for automobile and automobile accessories',
      descriptionHtml: `<div><p>
      The WHEELS gift card from Zaggle can be used for purchases of automobile and automobile accessories across India.
        </p>
      <p className="padding-t-1">The Wheel Gift Card is a non-reloadable card that comes with a 1-year validity period and a maximum load limit of 10,000 INR.
      </p></div>`,
      imageTitle: '',
      imageDescription: endPoints.WHEELS_GIFT_CARD,
    },
    {
      id: '6',
      slug: 'petro-gift-card',
      name: 'Petro Gift Card',
      summary: 'Gift Card for payments at fuel stations',
      descriptionHtml: `<div><p>
      The PETRO Gift card from Zaggle is accepted at all
      fuel stations for the purchase of fuel and lubricants across India.
    </p>
    <p className="padding-t-1">This card is the perfect solution for the corporates to meet the commute expenses of the employees.</p>
    <p>
      The Petro Gift Card is a non-reloadable card which comes with a 1-year validity period and a maximum load limit of 10,000 INR
    </p></div>`,
      imageTitle: '',
      imageDescription: endPoints.PETRO_GIFT_CARD,
    },
    {
      id: '7',
      slug: 'kohinoor-gift-card',
      name: 'Kohinoor Gift Card',
      summary: 'Gift Card for shopping at jewellery stores',
      descriptionHtml: `<div><p>
        The KOHINOOR gift card is accepted at ALL jewelry retail stores that accept cards as a means of payment and online jewelry portals like bluestone.com and caratlane.com
      </p>
      <p className="padding-t-1" >
        The Kohinoor Gift Card is a non-reloadable card which comes with a 1-year validity period and a maximum load limit of 10,000 INR The Card can be used at all jewelry outlets. The major outlets are:
      </p></div>`,
      imageTitle: endPoints.KOHINOOR_GIFTCARD_PARTNER_LOGO,
      imageDescription: endPoints.KOHINOOR_GIFT_CARD,
    },
  ],
};

export { EDGE_LANDING_CONSTANTS };



// WEBPACK FOOTER //
// client/containers/EdgeLanding/constants.js